module.exports = __webpack_public_path__ + "img/closeLockIcon.40d4f6b8.png";